import { useAtomValue } from 'jotai';
import { tableMetricsAtom } from '../atoms';
import type { AppFlowMetadataScope, AppFlowMetadata } from '@src/hooks/flow/useFlowConfigs';

export function useFlowScopeMetrics(
  dimensionScope: AppFlowMetadataScope,
  flowConfig?: AppFlowMetadata,
) {
  const { metrics, orderBy } = useAtomValue(tableMetricsAtom);

  if (!flowConfig)
    return {
      metrics: undefined,
      orderBy: undefined,
    };

  const isFlowSpecialScope = ['error', 'service'].includes(dimensionScope);
  const forcedMetrics = new Set(
    isFlowSpecialScope
      ? flowConfig.metaDefinition.metrics
          .filter((it) => it.scope === dimensionScope)
          .map((it) => it.identifier)
      : [],
  );
  const availableMetrics = new Set(
    flowConfig.metaDefinition.metrics
      .filter((it) => !isFlowSpecialScope || it.scope === 'global')
      .map((it) => it.identifier),
  );

  const metricsSet = new Set([
    ...forcedMetrics,
    ...metrics.filter((it) => availableMetrics.has(it)),
  ]);
  const metricsArray = Array.from(metricsSet);

  return {
    metrics: metricsArray,
    orderBy: orderBy && metricsSet.has(orderBy) ? orderBy : metrics[0],
  };
}
